import { createNamespacedHelpers } from '../../../core/services';
import { POSTER_SERVICES_NAMESPACE } from '../constants';

const { getService: getPosterService, addService: addPosterService } = createNamespacedHelpers(
  POSTER_SERVICES_NAMESPACE
);

export { getPosterService, addPosterService };
